import React, { useState } from "react";
import PropTypes from "prop-types";
import HPOTree from "../../../../components/atoms/HPOTree";
import { pluralize } from "../../../../common/helpers/helpers";

const SuggestedPhenotypes = ({
  suggestedPhenotypes,
  genes,
  updateNumberOfSelections,
}) => {
  const [collapsed, setCollapsed] = useState(true);

  const associatedPhenotypes = suggestedPhenotypes[0]?.diseases?.length || 0;
  return (
    <div className="row tw-mb-8">
      <div className="col-12 col-xs-12">
        <div>
          <label
            onClick={() => setCollapsed(!collapsed)}
            className="tw-text-base tw-mb-0 tw-block tw-cursor-pointer"
            style={{ fontSize: "1.1rem" }}
          >
            We found {associatedPhenotypes} phenotypes associated with
            {pluralize(genes?.length, " gene ", " genes ")}
            <strong>{genes.join(", ")}</strong>
            <span className="tw-text-primary tw-inline-block tw-ml-2 hover:tw-underline">
              {collapsed ? "View suggestions" : "Hide suggestions"}
            </span>
            <i
              className={`varsome-icons tw-hidden icon-chevron-${
                collapsed ? "down" : "up"
              } open tw-text-primary tw-text-sm tw-ml-2`}
            />
          </label>
          <div
            className={
              collapsed ? "saphetor_hpoTree varsome-hidden" : "saphetor_hpoTree"
            }
          >
            <HPOTree
              checkBoxes={true}
              HPOTree={{ hpo: suggestedPhenotypes }}
              updateNumberOfSelections={updateNumberOfSelections}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

SuggestedPhenotypes.propTypes = {
  suggestedPhenotypes: PropTypes.arrayOf(
    PropTypes.shape({
      diseases: PropTypes.arrayOf(
        PropTypes.shape({
          disease_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
          disease_name: PropTypes.string,
          doid_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          mondo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          omim_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          orphanet_id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
          ]),
          phenotypes: PropTypes.arrayOf(
            PropTypes.shape({
              phenotype_id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
              ]),
              phenotype_name: PropTypes.string,
              hpo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
          ),
        })
      ),
    })
  ),
  genes: PropTypes.arrayOf(PropTypes.string),
  updateNumberOfSelections: PropTypes.func.isRequired,
};

SuggestedPhenotypes.defaultProps = {
  suggestedPhenotypes: null,
  genes: null,
};

export default SuggestedPhenotypes;
